import gql from 'graphql-tag';

export const DELETE_ACCOMMODATION = gql`
  mutation deleteAccommodation($id: Int!) {
    deleteAccommodation(id: $id) {
      id
    }
  }
`;

export const CREATE_ACCOMMODATION = gql`
  mutation createAccommodation(
    $photo: Upload!
    $accommodation: AccommodationInput!
    $addOns: [AddOnInput]
    $mandatoryFees: [MandatoryFeeInput]
    $businessOwnerId: Int
    $deactivationPeriods: [DeactivationPeriodsInput]
  ) {
    createAccommodation(
      photo: $photo
      businessOwnerId: $businessOwnerId
      accommodation: $accommodation
      addOns: $addOns
      mandatoryFees: $mandatoryFees
      deactivationPeriods: $deactivationPeriods
    ) {
      id
    }
  }
`;

export const UPDATE_ACCOMMODATION = gql`
  mutation updateAccommodation(
    $photo: Upload
    $businessOwnerId: Int
    $accommodation: AccommodationInput
    $addOns: [AddOnInput]
    $deletedAddOns: [Int]
    $mandatoryFees: [MandatoryFeeInput]
    $deletedMandatoryFees: [Int]
    $deletedRelatedActivities: [Int]
    $deletedPlatforms: [Int]
    $deactivationPeriods: [DeactivationPeriodsInput]
  ) {
    updateAccommodation(
      photo: $photo
      businessOwnerId: $businessOwnerId
      accommodation: $accommodation
      addOns: $addOns
      deletedAddOns: $deletedAddOns
      mandatoryFees: $mandatoryFees
      deletedMandatoryFees: $deletedMandatoryFees
      deletedRelatedActivities: $deletedRelatedActivities
      deletedPlatforms: $deletedPlatforms
      deactivationPeriods: $deactivationPeriods
    ) {
      accommodation {
        id
      }
    }
  }
`;
